import React from "react";
import {Container, Typography} from "@mui/material";
import {GameplayComponent} from "../Component/GameplayComponent.tsx";
import {findById} from "../Data/KeywordSet.ts";
import {useParams} from "react-router";

export function GamePage(): React.ReactElement {
	const params = useParams();
	if (params.id === undefined) {
		return <></>;
	}

	const set = findById(params.id);
	if (set === undefined) {
		return <></>
	}

	return <Container maxWidth="lg" sx={{textAlign: "center", my: 3}}>
		<Typography variant="h3" sx={{my: 3}}>{set.name}</Typography>
		<GameplayComponent set={set}/>
	</Container>
}
